import React, { useEffect, useRef, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { IoIosMore } from "react-icons/io";

export default function NavBar({ item, onSearch, searchPlaceholder = "search" }) {
  const dropdownRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  function triggerSearch() {
    if (onSearch) onSearch(searchValue);
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") {
      triggerSearch();
    }
  }

  return (
    <div className="bg-marginColor-shade1 mt-16 mx-12 px-3 py-2 md:py-3 md:m-0 md:flex rounded-md flex items-center justify-between">
      <div className="flex items-center">
        <div className="relative">
          <button
            className="hidden md:block"
            onClick={() => setShowMenu(!showMenu)}
          >
            <IoIosMore className="font-bold text-[22px]" />
          </button>

          {showMenu && (
            <div className="w-[200px] absolute" ref={dropdownRef}>
              <div
                className="bg-[#D9D9D9] flex flex-col px-3 py-2 gap-3 rounded-lg"
                onClick={() => setShowMenu(false)}
              >
                {item?.map((item) => (
                  <div
                    className={`flex items-center gap-1 hover:cursor-pointer ${item?.value === item?.title ? `text-baseColor-button` : `text-black`} `}
                    key={item?.title}
                    onClick={item?.onClick}
                  >
                    {item?.icon}
                    {item?.title}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-7 flex-wrap md:hidden">
          {item?.map((item) => (
            <div
              className={`flex items-center gap-1 hover:cursor-pointer ${item?.value === item?.title ? `text-baseColor-button` : `text-black`} `}
              key={item?.title}
              onClick={item?.onClick}
            >
              {item?.icon}
              {item?.title}
            </div>
          ))}
        </div>
      </div>

      {onSearch && (
        <div className="flex items-center bg-white rounded-md">
          <input
            className="outline-none pl-2 rounded-l-md"
            placeholder="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <div
            className="bg-baseColor-button p-[5px] rounded-r-md cursor-pointer"
            onClick={triggerSearch}
          >
            <FaSearch />
          </div>
        </div>
      )}
    </div>
  );
}